// extracted by mini-css-extract-plugin
module.exports = {"warning":"a10a3f92e9--warning--FextH","warn":"a10a3f92e9--warn--BrNd0","label":"a10a3f92e9--label--ZzAdx"};